<script>
    import { fly } from 'svelte/transition';

    let {
        visited = {},
        total = 100,
        old_visited = 0,
        visited_bold = true,
        highlight_progress = true,
        shrink_on_mobile = false
    } = $props();

    let visited_cnt = $derived((typeof visited === 'object' && visited !== null) ? Object.keys(visited).length : 0);
    let done_pc = $derived(Math.round(visited_cnt / total * 100));

</script>
{#key visited_cnt}<span style="display: inline-block" class:bold={visited_bold} class:has-text-success="{highlight_progress && (visited_cnt > Number(old_visited))}" in:fly|local={{ y: -20 }}>{visited_cnt}</span>{/key}<span class:is-hidden-mobile={shrink_on_mobile}>&nbsp;/&nbsp;{total}&nbsp;({done_pc}%)</span>
<style>
    .bold { 
        font-weight: bold; 
    }
</style>